import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const LicenseRequestRoutes = [
  {
    path: '/licenses',
    name: 'ListLicenseRequests',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'license:list'
    }
  },
  {
    path: '/license',
    name: 'CreateLicenseRequest',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'license:create'
    }
  },
  {
    path: '/license/:id',
    name: 'UpdateLicenseRequest',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'license:update'
    }
  },
  {
    path: '/license/view/:id',
    name: 'GetLicenseRequest',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'license:get'
    }
  }
]
